import { ChangeDetectionStrategy, Component, Injector, Input, OnInit } from '@angular/core';

import { Widget } from '../../../models/form-widget.model';
import { WidgetBase } from '../../../models/widget-base';

@Component({
  selector: 'app-fb-label',
  templateUrl: './fb-label.component.html',
  styleUrls: ['./fb-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FbLabelComponent extends WidgetBase implements OnInit {
  @Input() public override set payload(value) {
    this._payload = value;
    this.ready.next(true);
  }
  public override get payload() {
    return this._payload;
  }

  constructor(private injector: Injector) {
    super(injector);
  }

  ngOnInit() {}
}
